import React, { useState, useEffect, useContext } from 'react'
import { Card, Select, Row, Col, Popconfirm, Typography, Badge, Button, Radio, Modal, Tabs, notification, TimePicker, Space, Form, Collapse } from 'antd';
import moment from 'moment';
import _ from "lodash"
import { BlankSpace, PageContainer } from "../../component/Xcomponent";
import { connect } from "react-redux";
//Actions
import { getQuickSupport } from '../../action/getQuickSupport';
import HeaderContext from '../../context/HeaderContext';

const { Panel } = Collapse;

const QuickSupport = props => {
	const {
		getQuickSupport, getQuickSupportState
	} = props;
	const [quickSupportData, setQuickSupportData] = useState([]);
	const [dataFound, setDataFound] = useState();
	const {setTitle} = useContext(HeaderContext);
  	setTitle("Quick Support");
	
	const onChange = (key) => {
		console.log(key);
	};
	useEffect(() => {
		getQuickSupport({})
		//let data = true;
		//(async () => {
		//	await data
		//})()
	}, [])
	useEffect(() => {
		if (getQuickSupportState.apiState === "success") {   

			console.log("getQuickSupportState", getQuickSupportState)
			setQuickSupportData(getQuickSupportState.result);
		}
		
	}, [getQuickSupportState])
	const QuickSupportParent = () => {

		return <><Collapse onChange={onChange}>
			{
				quickSupportData.map((category, id1) => <Panel header={category.name}>{

					QuickSupportChild(category)



				}</Panel>
				)
			}
		</Collapse>
		</>
	}

	const QuickSupportChild = (category) => {
		return <>
			{category.children.length > 0 &&
				category.children.map((child_category, id2) =>
					<>
						<Collapse >
							<Panel header={child_category.name}>
								{QuickSupportChild(child_category)}
							</Panel>
						</Collapse>
					</>
				)
			}
			<br></br>
			{category.quick_support_question_answer.map((questionAnswers) =>
				<>
					<div>
						<h6>{questionAnswers.question}</h6>
						<p className='supportText' style={{fontSize:"small"}} dangerouslySetInnerHTML={{ __html: decodeURIComponent(questionAnswers.answer) }} />
					</div>
				</>
			)}
		</>
	}
	return (
		<div>
			<PageContainer>
				{getQuickSupportState.apiState === "success" &&
				<div style={{ width: '100%', justifyContent: "flex-start" }}>
					<h4>Quick Support</h4>
					<QuickSupportParent></QuickSupportParent>
					</div>
				}
			</PageContainer>
		</div>
	)
};

const mapStateToProps = (state) => ({
	getQuickSupportState: state.getQuickSupport,

});

const mapDispatchToProps = (dispatch) => ({
	getQuickSupport: (params) => dispatch(getQuickSupport(params)),

});

export default connect(mapStateToProps, mapDispatchToProps)(QuickSupport);
